<template>
    <div class="product-tags">
        <template
            v-for="(tag, i) in ProductTag"
            :key="i"
        >
            <span 
                class="tag_detail" 
                :class="[
                    { new: tag === 'New' },
                    props.classCustomise
                ]"
                >
  {{ tag }}
</span>
            <br>
        </template>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps(["data","classCustomise"]);
    const ProductTag = computed(() => props.data);
</script>